import { render, staticRenderFns } from "./BsPagination.vue?vue&type=template&id=c9fbf64c&"
import script from "./BsPagination.vue?vue&type=script&lang=js&"
export * from "./BsPagination.vue?vue&type=script&lang=js&"
import style0 from "./BsPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports